import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import { AuthContext } from "../AuthContext";
import { getApi } from "@beeldit/core/helpers/api";

function useGetMe() {
  const { setUser } = useContext(AuthContext);
  const errorHandler = useErrorHandler();

  return (
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
    getApi()
      .get(`/users/me`)
      .then((response: any) => {
        let data = response.data;
        data = onSuccess(response.data);
        setUser(data);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGetMe;
